export const HIERA_WEB_VERSION = "0.1.73";
